import { PropsWithChildren } from 'react';
import { StackProps, Text } from '@chakra-ui/react';
import { SectionTitle } from '../atoms/Title.tsx';
import { Card } from '../atoms/Card.tsx';

export function TitledBox({
  title,
  description = '',
  titleSize = '12pt',
  children,
  ...props
}: { title: string; titleSize?: string | number; description?: string } & PropsWithChildren & StackProps) {
  return (
    <Card {...props}>
      <SectionTitle marginTop={'-2px'} fontSize={titleSize} marginBottom={'-8px'}>
        {title}
      </SectionTitle>
      <Text paddingBottom={'10px'} fontSize={'10pt'} color={'rgb(119, 119, 119)'}>
        {description}
      </Text>
      {children}
    </Card>
  );
}
